import React from "react";
import UserListing from "../components/ManageUser/UserListing";
import {
  getUserList,
  getAffiliateUser,
  getAffiliateUserList,
} from "../services/manage-user";
import { roleListing } from "../services/manage-roles";
import Pagination from "../components/Pagination";
import SearchFilter from "../components/ManageUser/SearchFilter";
import { Context } from "../config/store";
import { objectsForEach } from "../common/objectToArray";
import TableHeader from "../components/ManageUser/TableHeader";
import AddAffiliateUser from "../components/ManageUser/AddAffiliateUser";
import { downloadFile } from "../common/download";
import { toast } from "react-toastify";
import message from "../constant/message";
import UploadUserModal from "../components/ManageUser/UploadUserModal";
import LenderUgroService from "../services/lender";
import { useNavigate } from "react-router-dom";
import "./style.css";
import objectToQueryParams from "../common/objectToQueryParams";
import TableLoading from '../components/Common/Table/TableLoading';

const ManageUsers = ({ type }) => {
  let sessionStorageData = JSON.parse(sessionStorage.getItem('searchData')) || {};
  let { org_page = 1 } = sessionStorageData;
  const queryString = objectToQueryParams(sessionStorageData);
  const [users, setUsers] = React.useState([]);
  const [pagination, setPaginationData] = React.useState({});
  const [page, setPage] = React.useState(org_page);
  const [modalState, toggleModal] = React.useState(false);
  const [queryParams, setQueryParams] = React.useState(queryString);
  const [selectedUserId, setSelectedUserId] = React.useState("");
  const { state } = React.useContext(Context);
  const [exportLoading, setExportLoading] = React.useState(false);
  const [userModalState, setUserModalState] = React.useState(false);
  const [roles, setRoles] = React.useState([]);
  const navigation = useNavigate();
  const [loading, setLoading] = React.useState(false);

  // React.useEffect(() => {
  //   if (state.userType === "admin" || state.userType === "lender") getUsers();
  //   else getAffiliateUsersList();
  //   getRoles();
  // }, [page, queryParams]);

  React.useEffect(() => {
    getUsers(false, false);
    getRoles(false);
  }, [page]);

  React.useEffect(() => {
    getUsers(false, true);
    getRoles(true);
  }, [queryParams]);
  /**
   *
   */
  const getUsers = async (exportList, paramsChanged) => {
    let response;
    setLoading(true);

    if (type === "lender") {
      response = await LenderUgroService.getUserList({
        type: state.userType,
        page,
        queryParams,
        exportList,
      });
      response = response.data;
      setLoading(false);
    } else {
      response = await getUserList({
        page: paramsChanged ? 1 : page,
        queryParams,
        exportList,
      });
       setLoading(false);
    }
    if (response?.status?.code === 1) {
      const data = response.data?.resource;
      setUsers(data?.data || []);
      let searchDataNew = {
        ...sessionStorageData,
        org_page: paramsChanged ? 1 : page,
      };
      sessionStorage.setItem("searchData", JSON.stringify(searchDataNew));
      setPaginationData(data?.pagination || {});
    } else if (exportList && !response?.status) {
      downloadFile(
        response,
        `users_${new Date()?.toISOString()?.split("T")[0]}`
      );
    } else {
      let error = response?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR);
    }
  };

  /*** */
  const getRoles = async (paramsChanged) => {
    const response = await roleListing({
      type,
      page: paramsChanged ? 1 : page,
      queryParams,
      per_page: 100,
    });
    if (response?.status?.code === 1) {
      const data = response.data?.resource;
      const rolelist = data?.data.map((item) => {
        return { value: item?.role_name, id: item?.role_id };
      });
      setRoles(rolelist || []);
      // setPaginationData(data?.pagination || {});
    } else {
      let error = response?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR);
    }
  };
  /**
   *
   */
  const getAffiliateUsersList = async (exportList) => {
    const response = await getAffiliateUserList({
      page,
      queryParams,
      exportList,
    });

    if (response?.status?.code === 1) {
      const data = response.data?.resource;
      setUsers(data?.data || []);
      setPaginationData(data?.pagination || {});
    } else if (exportList && !response?.status) {
      downloadFile(response);
    } else {
      let error = response?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR);
    }
  };
  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  const exportUsers = async () => {
    setExportLoading(true);
    await getUsers(true, false);
    setExportLoading(false);
  };
  const toggleUserModal = () => {
    navigation("/admin/manage-users/add");
  };

  return (
    <>
      <div>
        {state.userType === "affiliate" && (
          <a
            href="#"
            className="btn btn-custom btn-custom-height float-right mt-3"
            onClick={(e) => {
              e.preventDefault();
              toggleModal(true);
            }}
          >
            Add User
          </a>
        )}
      </div>
      <div className="clearfix" />
      {state.userType === "admin" && (
        <SearchFilter
          userType={state.userType}
          setQueryParams={setQueryParams}
          roleList={roles || []}
          businessType={state?.config?.businesstype || []}
        />
      )}
      {modalState && (
        <AddAffiliateUser
          user_id={selectedUserId}
          state={modalState}
          reloadTable={getAffiliateUsersList}
          toggleModal={toggleModal}
        />
      )}
      {userModalState && (
        <UploadUserModal
          userType={state.userType}
          state={userModalState}
          toggleModal={toggleUserModal}
          reloadTable={getAffiliateUsersList}
        />
      )}
      {state.userType === "admin" && (
        <div className="d-flex justify-content-end mt-2">
          {checkHasPermission("add-backend-user") && (
            <button
              onClick={toggleUserModal}
              type="button"
              className="btn btn-custom btn-custom-height ml-3"
            >
              <i class="fa fa-user mr-1" aria-hidden="true"></i>
              {"Add User"}
            </button>
          )}
          <button
            onClick={exportUsers}
            type="button"
            className="btn btn-custom btn-custom-height ml-3 d-flex"
            disabled={exportLoading}
          >
            <i class="fa fa-users mr-1" aria-hidden="true"></i>
            {exportLoading ? <div className="loader" /> : "Export Excel"}
          </button>
        </div>
      )}
      <div className="panel manageUsers">
        <div className="table-responsive ">
          <table className="table table-striped">
            <TableHeader type={state.userType} />
            <tbody className='position-relative'>
            {loading ? <TableLoading/> :
            users.map(({ user_id, ...rest }) => (
              <UserListing
                checkHasPermission={checkHasPermission}
                pageType={type}
                setSelectedUserId={setSelectedUserId}
                toggleModal={toggleModal}
                key={user_id}
                type={state.userType}
                user_id={user_id}
                {...rest}
              />
            ))}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        setPage={setPage}
        total_pages={pagination.total_pages}
        total={pagination.total}
        // currentPageNumber={page}
      />
    </>
  );
};

export default ManageUsers;
